// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "c18d7fd6a617df68","191": "eb33119c1f659ac2","396": "4bc6958aa12ec57a","460": "8de80de0030c18d0","498": "4b946af9cd004fce","917": "cf92e6967fd39f9f","985": "2e4cb84747a0d0ca",}[chunkId] + ".chunk.js"
}